import React, { FC } from "react";
import { clss } from "../../utils/helpers/styleHelpers";
import { useTranslate } from "../../utils/hooks/useTranslate";

import styles from "./tabs.module.scss";

type TabsPropTypes = {
  setSelectedTab: (index: number) => void;
  selectedTab: number;
  tabs: string[];
};

const Tabs: FC<TabsPropTypes> = (props) => {
  const { tabs, selectedTab, setSelectedTab } = props;
  const { t } = useTranslate();

  return (
    <ul className={styles.wrapper}>
      {tabs.map((tab, index) => (
        <li
          key={tab}
          className={clss([
            index === selectedTab ? styles.selectedTab : styles.tab,
          ])}
          onClick={() => setSelectedTab(index)}
        >
          {t(tab)}
        </li>
      ))}
    </ul>
  );
};

export default Tabs;
